import service from '../../api';

export default {
    searchall(q) {
        return service.post('artists', {q});
    },
    everything() {
        return service.get('/artists/all');
    },
    onboarding() {
        return service.get('artists/onboarding');
    },
    onboardingSearch(search) {
        return service.get('artists/onboarding/search/' + search);
    },
    all(page = 1) {
        return service.get('/artists?page=' + page);
    },
    get(id) {
        return service.get('/artists/' + id);
    },
    update(id, data) {
        data['_method'] = 'patch';
        return service.post('/artists/' + id, data);
    },
    create(data) {
        return service.post('/artists', data);
    },
    search(search, page = 1) {
        return service.get('/artists/search/' + search + '?page=' + page);
    },
    destroy(id) {
        let data = { '_method': 'delete' };
        return service.post('/artists/' + id, data);
    },
}
